import React, {useMemo, useState, useEffect} from 'react';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {
    Box,
    Checkbox,
    FormControl, InputLabel,
    Link,
    MenuItem,
    Modal,
    OutlinedInput,
    Select,
    Switch, TextField,
    Typography, Button,
    styled
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Collapse from "@mui/material/Collapse";
import TableContainer from "@mui/material/TableContainer";
import {
    findProfit,
    findTotal
} from "../../../Orders/OrdersChange/OrdersChangeTable/OrdersChangeTableBody/OrdersChangeTableBodyItem/OrderChangeTableBodyItem";
import debounce from 'lodash.debounce'

import { ReactComponent as Like } from '../../../../assets/svg/Like.svg'
import { ReactComponent as InProgress } from '../../../../assets/svg/inProgress.svg'
import { ReactComponent as Production } from '../../../../assets/svg/cap.svg'
import { ReactComponent as Delivery } from '../../../../assets/svg/scooterDelivery.svg'
import { ReactComponent as CONGEDOR } from '../../../../assets/svg/Congelador.svg'
import { ReactComponent as Plus } from '../../../../assets/svg/Plus.svg'
import {mainApi} from "../../../../store/services/mainApi";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from '@mui/material/AvatarGroup';

import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import ListItemButton from '@mui/material/ListItemButton';
import OrderChangeTableBodyModal
    from "../../../Orders/OrdersChange/OrdersChangeTable/OrdersChangeTableBody/OrdersChangeTableBodyModal/OrderChangeTableBodyModal";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramAppIcon from "@mui/icons-material/Telegram";


function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ').length < 2 ? name.split(' ')[0][0] : name.split(' ')[0][0] + "" + name.split(' ')[1][0] }`,
    };
}


const ItemsProductionClientItem = ({rowStyle, handleSendDriverInformSendWhatsapp, groupedClient, setSelectedItems, drivers, uniqueProveedors, item, openRows, toggleRowOpen, selectedItems, checkBoxStyle, handleNestedSelect, handleTopLevelSelect, rowStyleMap, userColumnsFieldsClient}) => {
    console.log(groupedClient)
    const [changeObj] = mainApi.useChangeOrderObjMutation()
    const [changeObjStock] = mainApi.useChangeObjStockMutation()
    const [changeObjProveedor] = mainApi.useChangeObjProveedorMutation()
    const [changeObjPrice] = mainApi.useChangeObjEntryPriceMutation()
    const [changeObjInform] = mainApi.useChangeObjInformMutation()

    const [changeCompradorOrderId, setChangeCompradorOrderId] = useState([])

    const [changeComprador, setChangeComprador] = useState(false)

    const [selectProveedor, setSelectProveedor] = useState()

    const [inputInformation, setInputInformation] = useState(item.products.map(el => el.description).join(","))
    const [inputStock, setInputStock] = useState(item.totalStock)
    const [inputEntryPrice, setInputEntryPrice] = useState(item.products[0].ourPrice)

    const [inputProveedor, setInputProveedor] = useState(item.products[0].proveedor)


    const [checked, setChecked] = useState([...item.products.map(el => el.comprador).flat()].filter((item, index, self) =>
        item != null && self.findIndex(el => el?._id === item?._id) === index
    ) || []);


    const [compradorState, setCompradorState] = useState(() =>
        item.products.reduce((state, order) => {
            state[order._id] = order.comprador || [];
            return state;
        }, {})
    );


    // Обработчик изменения input
    const handleToggleStock = (value) => {
        setInputStock(value); // Обновляем значение input
    };

    const handleToggleProveedor = (value) => {
        setInputProveedor(value)
    };

    const handleToggleEntryPrice = (value) => {
        setInputEntryPrice(value)
    };

    const handleToggleInformation = (value) => {
        setInputInformation(value)
    };

    const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
        padding: 0,
        '& .MuiSvgIcon-root': {
        width: 24,
        height: 24,
        borderRadius: '7px',
        border: '1px solid #d9d9d9',
        transition: 'all 0.2s',
        },
        '&.Mui-checked': {
        color: '#176318',
        '& .MuiSvgIcon-root': {
            borderColor: '#176318',
        }
        },
        '&:hover': {
        '& .MuiSvgIcon-root': {
            borderColor: '#176318',
            backgroundColor: 'rgba(23, 99, 24, 0.05)'
        }
        }
    }));
    const CheckedIcon = () => (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.15124 14.737C6.7509 15.2616 5.96111 15.2614 5.561 14.7366L2.407 10.5995C2.00764 10.0756 1.21971 10.0743 0.818564 10.5968L0.465911 11.0561C0.190927 11.4143 0.190078 11.9123 0.46384 12.2714L5.56063 18.9569C5.96084 19.4818 6.75092 19.4818 7.15114 18.9569L19.5378 2.70918C19.8108 2.3511 19.8108 1.85472 19.5378 1.49663L19.1917 1.04265C18.7916 0.517833 18.0018 0.517653 17.6015 1.04229L7.15124 14.737Z" fill="#176318" />
        </svg>
    );
    const CheckIcon = () => (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.15124 14.737C6.7509 15.2616 5.96111 15.2614 5.561 14.7366L2.407 10.5995C2.00764 10.0756 1.21971 10.0743 0.818564 10.5968L0.465911 11.0561C0.190927 11.4143 0.190078 11.9123 0.46384 12.2714L5.56063 18.9569C5.96084 19.4818 6.75092 19.4818 7.15114 18.9569L19.5378 2.70918C19.8108 2.3511 19.8108 1.85472 19.5378 1.49663L19.1917 1.04265C18.7916 0.517833 18.0018 0.517653 17.6015 1.04229L7.15124 14.737Z" fill="none" />
        </svg>
    );


    return (
        <React.Fragment key={item.clientInfo.id}>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell sx={rowStyleMap}>
                    <Box className='LogisticOperation__filtersBar__container__item__grouping' 
                    sx={{ width: '24px !important', height: '24px', backgroundColor: '#fff' }}>
                        <CustomCheckbox
                        // Checked if all nested orders are selected
                        checked={item.products.every((order) =>
                            selectedItems.some(item =>
                                (item._id + item.items._id) === (order._id + order.items._id)
                            )
                        )}
                        // onChange={(event) => handleTopLevelSelect(event, groupedClient)}
                        icon={<CheckIcon />}
                        checkedIcon={<CheckedIcon />}
                        />
                    </Box>
                </TableCell>

                {userColumnsFieldsClient.includes('buyer') && <TableCell sx={rowStyleMap} align="center">
                    <Box align="center">
                        {drivers && compradorState[groupedClient._id]?.length ?
                            <AvatarGroup sx={{ justifyContent: "center" }} max={3} onClick={() => {
                                setChangeComprador(prev => !prev);
                                setChangeCompradorOrderId(groupedClient.orders);
                            }}>
                                {compradorState[groupedClient._id].map(driver => (
                                    <Avatar key={driver._id} {...stringAvatar(driver.name || "No Name")} sx={{width: '30px', height: '30px', fontSize: '10px'}}/>
                                ))}
                            </AvatarGroup>
                            :
                            <Avatar onClick={() => {
                                setChangeComprador(prev => !prev);
                                setChangeCompradorOrderId(groupedClient.orders);
                            }} align="center" sx={{ backgroundColor: "purple", width: '30px', height: '30px', fontSize: '10px' }}>+</Avatar>
                        }
                    </Box>
                </TableCell>}

                {userColumnsFieldsClient.includes('client') && <TableCell sx={rowStyleMap} onClick={() => toggleRowOpen(item.clientInfo.id)}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        {item.products[0].orders[0].userAcc.name + (" (" + item.products[0].orders[0].tradeName || item.products[0].orders[0].userAcc.tradeName) + ")"}
                        <Box sx={{ width: '15px',}}>
                            {openRows[item.sku] ? <svg width="15" height="30" viewBox="0 0 15 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.91421 11C1.02331 11 0.577142 12.0771 1.20711 12.7071L6.79289 18.2929C7.18342 18.6834 7.81658 18.6834 8.20711 18.2929L13.7929 12.7071C14.4229 12.0771 13.9767 11 13.0858 11H1.91421Z" fill="#4C4C4C" />
                            </svg> :
                            <svg width="15" height="30" viewBox="0 0 15 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.91421 19C1.02331 19 0.577142 17.9229 1.20711 17.2929L6.79289 11.7071C7.18342 11.3166 7.81658 11.3166 8.20711 11.7071L13.7929 17.2929C14.4229 17.9229 13.9767 19 13.0858 19H1.91421Z" fill="#4C4C4C" />
                            </svg>}
                        </Box>
                    </Box>
                </TableCell>}
                {userColumnsFieldsClient.includes('order id') && <TableCell sx={rowStyleMap} align="right">
                    <Link target="_blank" href={"/admin/orders/" + item.products[0].orders[0]._id}>
                        {item.products[0].orders[0]._id.slice(-6)}
                    </Link>
                </TableCell>}
                {userColumnsFieldsClient.includes('quantity') && <TableCell sx={rowStyleMap} align="right">
                    {item.products[0].orders[0].items.quantityOrder + " " + item.products[0].orders[0].items.unit}
                </TableCell>}
                {userColumnsFieldsClient.includes('stock') && <TableCell sx={rowStyleMap} align="right">
                    {inputStock + " " + item.products[0].orders[0].items.unit}
                </TableCell>}
                {userColumnsFieldsClient.includes('total') && <TableCell sx={rowStyleMap} align="right">
                    {item.products[0].orders[0].items.quantity + " " + item.products[0].orders[0].items.unit}
                </TableCell>}
                {userColumnsFieldsClient.includes('delivery') && <TableCell sx={rowStyleMap} align="right">{item.products[0].orders[0].deliveryDate + " " + item.products[0].orders[0].deliveryTime}</TableCell>}

                {userColumnsFieldsClient.includes('total price') && <TableCell sx={rowStyleMap} align="right">
                    {parseFloat(item.products[0].orders[0].items.quantity * item.products[0].orders[0].items.marketPriceCP).toFixed(2)  + "€"}
                </TableCell>}

            </TableRow>

            <TableRow>
                <TableCell sx={rowStyleMap} style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={14}>
                    <Collapse in={openRows[item.clientInfo.id]} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 0, borderLeft: '3px solid #176318' }}>
                            <Table size="small" aria-label="purchases" className='ItemsProductionClient__subTable'>
                                <TableHead sx={rowStyleMap}>
                                    <TableRow>
                                        <TableCell sx={rowStyle}>Item</TableCell>
                                        <TableCell sx={rowStyle} align="center">Quantity</TableCell>
                                        <TableCell sx={rowStyle} align="center">Stock</TableCell>
                                        <TableCell sx={rowStyle} align="center">Total</TableCell>
                                        <TableCell sx={rowStyle} align="center">Enter Proveedor</TableCell>

                                        <TableCell sx={rowStyle} align="center">Proveedor</TableCell>
                                        <TableCell sx={rowStyle} align="center">Enter Price</TableCell>

                                        <TableCell sx={rowStyle} align="center">Price</TableCell>
                                        <TableCell sx={rowStyle} align="center">Information</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {item.products.map((currItem) => (
                                        <TableRow key={item.products[0].orders[0]._id + item.products[0].orders[0].items._id}>
                                            <OrderChangeTableBodyModal
                                                editOrder={{}}
                                                setSelectedItems={setSelectedItems}
                                                order={{ ...item.products[0].orders[0], items: [item.products[0].orders[0].items] }}
                                                selectedItems={selectedItems.map(el => el.items)}
                                            />

                                            <TableCell sx={rowStyleMap}>
                                                {currItem.name}
                                            </TableCell>
                                            <TableCell sx={rowStyleMap} align="right">{currItem.quantity}</TableCell>
                                            <TableCell sx={rowStyleMap} align="center">
                                                <TextField 
                                                    sx={{
                                                        width: 80,
                                                        height: 30,
                                                        borderRadius: '7px',
                                                        border: '1px solid #d9d9d9',
                                                        '& .MuiSelect-select': {
                                                        fontWeight: 500,
                                                        fontSize: '12px',
                                                        color: '#2a2d2f',
                                                        height: '30px', // Добавлено для вертикального выравнивания
                                                        padding: '6px 12px', // Оптимизированный отступ
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                        },
                                                        '&:hover': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                        }
                                                        },
                                                        '&.Mui-focused': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                            boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
                                                        }
                                                        },
                                                        // Стили для иконки стрелки
                                                        'input': {
                                                            padding: '7px',
                                                            textAlign: 'center',
                                                            fontWeight: 500,
                                                            fontSize: '12px',
                                                            color: '#2a2d2f',
                                                        }
                                                    }}
                                                    id="outlined-basic" variant="outlined" color='success'
                                                    onChange={(e) =>
                                                        handleToggleStock(e.target.value)
                                                    }
                                                    defaultValue={inputStock}
                                                />
                                            </TableCell>
                                            <TableCell sx={rowStyleMap} align="right">{currItem.quantityOrder}</TableCell>
                                            <TableCell sx={rowStyleMap} align="center">
                                                <TextField
                                                sx={{
                                                    width: 180,
                                                    height: 30,
                                                    borderRadius: '7px',
                                                    border: '1px solid #d9d9d9',
                                                    '& .MuiSelect-select': {
                                                    fontWeight: 500,
                                                    fontSize: '12px',
                                                    color: '#2a2d2f',
                                                    height: '30px', // Добавлено для вертикального выравнивания
                                                    padding: '6px 12px', // Оптимизированный отступ
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                    },
                                                    '&:hover': {
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    }
                                                    },
                                                    '&.Mui-focused': {
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                        boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
                                                    }
                                                    },
                                                    // Стили для иконки стрелки
                                                    'input': {
                                                        padding: '7px',
                                                        textAlign: 'center',
                                                        fontWeight: 500,
                                                        fontSize: '12px',
                                                        color: '#2a2d2f',
                                                    }
                                                }}
                                                color='success' 
                                                onChange={(e) => handleToggleProveedor(e.target.value)}
                                                    defaultValue={inputProveedor}
                                                />
                                            </TableCell>
                                            <TableCell sx={rowStyleMap} align="center">
                                                <Select
                                                    labelId="demo-simple-checkbox-label"
                                                    id="demo-simple-checkbox"
                                                    color="success"
                                                    value={
                                                        selectProveedor
                                                    }
                                                    onChange={(e) => setSelectProveedor(e.target.value)}
                                                    input={<OutlinedInput label="Proveedor" />}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                            maxHeight: '200px',
                                                            marginTop: '5px',
                                                            borderRadius: '7px',
                                                            border: '1px solid #d9d9d9'
                                                            },
                                                        },
                                                    }}
                                                    sx={{
                                                        width: 120,
                                                        height: 30,
                                                        borderRadius: '7px',
                                                        border: '1px solid #d9d9d9',
                                                        '& .MuiSelect-select': {
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                            color: '#4c4c4c',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                        },
                                                        '&:hover': {
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                            }
                                                        },
                                                        '&.Mui-focused': {
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                            boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
                                                            }
                                                        }
                                                    }}
                                                >
                                                    {uniqueProveedors.map((e, ind) =>
                                                        <MenuItem key={ind} value={e}>{e}</MenuItem>
                                                    )}

                                                </Select>
                                            </TableCell>
                                            <TableCell sx={rowStyleMap} align="center">
                                                <TextField
                                                    sx={{
                                                        width: 80,
                                                        height: 30,
                                                        borderRadius: '7px',
                                                        border: '1px solid #d9d9d9',
                                                        '& .MuiSelect-select': {
                                                        fontWeight: 500,
                                                        fontSize: '12px',
                                                        color: '#2a2d2f',
                                                        height: '30px', // Добавлено для вертикального выравнивания
                                                        padding: '6px 12px', // Оптимизированный отступ
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                        },
                                                        '&:hover': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                        }
                                                        },
                                                        '&.Mui-focused': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                            boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
                                                        }
                                                        },
                                                        // Стили для иконки стрелки
                                                        'input': {
                                                            padding: '7px',
                                                            textAlign: 'center',
                                                            fontWeight: 500,
                                                            fontSize: '12px',
                                                            color: '#2a2d2f',
                                                        }
                                                    }}
                                                    onChange={(e) => handleToggleEntryPrice(e.target.value)}
                                                    defaultValue={inputEntryPrice}/>
                                            </TableCell>
                                            <TableCell sx={rowStyleMap} align="right">{(currItem.marketPriceCP * currItem.quantity).toFixed(2) + "€"}</TableCell>
                                            <TableCell sx={rowStyleMap} align="center">
                                                <TextField
                                                    sx={{
                                                        width: 80,
                                                        height: 30,
                                                        borderRadius: '7px',
                                                        border: '1px solid #d9d9d9',
                                                        '& .MuiSelect-select': {
                                                        fontWeight: 500,
                                                        fontSize: '12px',
                                                        color: '#2a2d2f',
                                                        height: '30px', // Добавлено для вертикального выравнивания
                                                        padding: '6px 12px', // Оптимизированный отступ
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                        },
                                                        '&:hover': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                        }
                                                        },
                                                        '&.Mui-focused': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none',
                                                            boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
                                                        }
                                                        },
                                                        // Стили для иконки стрелки
                                                        'input': {
                                                            padding: '7px',
                                                            textAlign: 'center',
                                                            fontWeight: 500,
                                                            fontSize: '12px',
                                                            color: '#2a2d2f',
                                                        }
                                                    }}
                                                    onChange={(e) => handleToggleInformation(e.target.value)}
                                                    defaultValue={inputInformation}/>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>


    );
};

export default ItemsProductionClientItem;